/// <amd-module name="Repos/Views/Settings/Repositories/Components/CrossRepoBranchPolicy" />
import React = require("react");
import { refToBranchOrTagName } from "Repos/Common/Util/Ref";
import { ISettingsViewService, SettingsTabIds } from "Repos/Views/Settings/Common/Services/SettingsViewService";
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IRepositoriesViewService } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { format } from "VSS/Core/Util/String";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Header, TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { Page } from "VSSUI/Page";
import { RepositoryPolicies } from "./RepositoryPolicies";

interface ICrossRepoBranchPolicyProps {}

export class CrossRepoBranchPolicy extends VssComponent<ICrossRepoBranchPolicyProps> {
    private svc: IRepositoriesViewService;

    public constructor(props: ICrossRepoBranchPolicyProps, context: IVssComponentContext) {
        super(props, context);

        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
    }

    public render = (): JSX.Element => {
        const settingsSvc = this.context.pageContext.getService<ISettingsViewService>("SettingsViewService");
        return (
            <Page className="flex-grow">
                <Observer selectedRefs={this.svc.getSelectedRefs()}>
                    {(props: { selectedRefs: string | undefined }) => {
                        return (
                            <>
                                <Header
                                    titleSize={TitleSize.Large}
                                    title={format(Resources.CrossRepoPoliciesTitle, this.getTitle(refToBranchOrTagName(props.selectedRefs!)))}
                                    backButtonProps={{
                                        onClick: this.onBackClick,
                                        subtle: true,
                                        href: settingsSvc.getUrl(undefined, undefined, SettingsTabIds.policies)
                                    }}
                                />

                                <div className="page-content page-content-top">
                                    <RepositoryPolicies />
                                </div>
                            </>
                        );
                    }}
                </Observer>
            </Page>
        );
    };

    private onBackClick = (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => {
        if (!event.shiftKey && !event.ctrlKey) {
            this.svc.setAllWithSinglePageHistoryEntry(undefined, undefined, "policies");
            event.preventDefault();
        }
    };

    private getTitle = (branch: string) => {
        if(branch === "~default") {
            return Resources.DefaultBranch;
        }

        return branch;
    }
}
